import { defineNuxtPlugin } from "nuxt/app";
import { dateFilters } from '~/filters/dateFilters';

export default defineNuxtPlugin(() => {
  const dynamicSrc = (url: string): string => {
    const assetsPath = '../assets'; // このファイルからの相対パス
    return new URL(`${assetsPath}${url}`, import.meta.url).href;
  };

  return{
    provide: {
      filters: {
        date: dateFilters,
        dynamicSrc
      },
    }
  };
});
